<template>
  <div class="export-container">
    <!-- 导出按钮组（不变） -->
    <div class=" flex-row top start" style="display: flex; gap: 10px; margin-bottom: 10px; flex-wrap: wrap">
      <div class="pointer active">
        <el-button type="primary" @click="OnCreateWord" :loading="isExportingWord" :disabled="isExportingWord || !hasData"> 下载到本地(Word) </el-button>
        <el-progress :percentage="wordPercentage" style="margin-top: 8px; width: 200px" v-if="!isExportingWord && wordPercentage > 0"></el-progress>
        <div v-if="isExportingWord" style="margin-top: 8px; color: #666; font-size: 12px">正在导出Word，请稍候...</div>
      </div>
      <div class="pointer active">
        <el-button type="success" @click="OnCreatePDF" :loading="isExportingPDF" :disabled="isExportingPDF || !hasData"> 下载到本地(PDF) </el-button>
        <el-progress :percentage="pdfPercentage" style="margin-top: 8px; width: 200px" v-if="!isExportingPDF && pdfPercentage > 0"></el-progress>
        <div v-if="isExportingPDF" style="margin-top: 8px; color: #666; font-size: 12px">正在导出PDF，请稍候...</div>
      </div>
    </div>

    <!-- 无数据提示（不变） -->
    <div v-if="!hasData && !isExportingWord && !isExportingPDF" style="margin-top: 8px; color: #999">暂无数据可导出</div>

    <!-- PDF导出容器（完全还原你截图的表格样式） -->
    <div ref="pdfContent" class="pdf-content" style="position: absolute; top: -9999px; left: -9999px; width: 210mm; padding: 15mm; background: #fff; font-family: 'Microsoft YaHei', 'SimHei', sans-serif">
      <h1 style="text-align: center; font-size: 18px; font-weight: bold; margin: 0 0 20px 0">{{ value?.Title || '企业学员培训记录' }}</h1>

      <!-- 基础信息表格（自适应宽度） -->
      <table style="width: 100%; border: 1px solid #000; font-size: 12px; border-collapse: collapse; margin-bottom: 15px;">
        <tr>
          <td style="width: 20%; padding: 6px 8px; border-right: 1px solid #000; border-bottom: 1px solid #000; font-weight: bold;">企业名称：</td>
          <td style="padding: 6px 8px; border-bottom: 1px solid #000;" colspan="3">{{ value?.Company?.Name || '无' }}</td>
        </tr>
        <tr>
          <td style="width: 20%; padding: 6px 8px; border-right: 1px solid #000; border-bottom: 1px solid #000; font-weight: bold;">培训周期：</td>
          <td style="padding: 6px 8px; border-right: 1px solid #000; border-bottom: 1px solid #000;">{{ ExamRange }}</td>
          <td style="width: 20%; padding: 6px 8px; border-right: 1px solid #000; border-bottom: 1px solid #000; font-weight: bold;">考核时间：</td>
          <td style="padding: 6px 8px; border-bottom: 1px solid #000;">{{ ExamDate }}</td>
        </tr>
        <tr>
          <td style="width: 20%; padding: 6px 8px; border-right: 1px solid #000; border-bottom: 1px solid #000; font-weight: bold;">培训主题：</td>
          <td style="padding: 6px 8px; border-right: 1px solid #000; border-bottom: 1px solid #000;">{{ value?.Title || '无' }}</td>
          <td style="width: 20%; padding: 6px 8px; border-right: 1px solid #000; border-bottom: 1px solid #000; font-weight: bold;">课件数量：</td>
          <td style="padding: 6px 8px; border-bottom: 1px solid #000;">{{ value?.VideoCount || 0 }}</td>
        </tr>
        <tr>
          <td style="width: 20%; padding: 6px 8px; border-right: 1px solid #000; border-bottom: 1px solid #000; font-weight: bold;">课件时长：</td>
          <td style="padding: 6px 8px; border-right: 1px solid #000; border-bottom: 1px solid #000;">{{ LessonsTimeLen }}</td>
          <td style="width: 20%; padding: 6px 8px; border-right: 1px solid #000; border-bottom: 1px solid #000; font-weight: bold;">参加考试人数：</td>
          <td style="padding: 6px 8px; border-bottom: 1px solid #000;">{{ UserCount || 0 }}</td>
        </tr>
        <tr>
          <td style="width: 20%; padding: 6px 8px; border-right: 1px solid #000; font-weight: bold;">考试通过人员：</td>
          <td style="padding: 6px 8px; border-right: 1px solid #000;">{{ CompleteCount || 0 }}</td>
          <td style="width: 20%; padding: 6px 8px; border-right: 1px solid #000; font-weight: bold;">考试未通过人数：</td>
          <td style="padding: 6px 8px;">{{ NoComplete || 0 }}</td>
        </tr>
      </table>

      <!-- 学员列表表格 -->
      <table style="width: 100%; border: 1px solid #000; font-size: 11px; border-collapse: collapse;">
        <thead>
          <tr style="background: #f0f0f0;">
            <th style="width: 6%; padding: 6px 4px; border-right: 1px solid #000; text-align: center; font-weight: bold;">序号</th>
            <th style="width: 10%; padding: 6px 4px; border-right: 1px solid #000; text-align: center; font-weight: bold;">头像</th>
            <th style="width: 10%; padding: 6px 4px; border-right: 1px solid #000; text-align: center; font-weight: bold;">姓名</th>
            <th style="width: 6%; padding: 6px 4px; border-right: 1px solid #000; text-align: center; font-weight: bold;">性别</th>
            <th style="width: 38%; padding: 6px 4px; border-right: 1px solid #000; text-align: center; font-weight: bold;">身份证</th>
            <th style="width: 14%; padding: 6px 4px; border-right: 1px solid #000; text-align: center; font-weight: bold;">学习结果</th>
            <th style="width: 6%; padding: 6px 4px; text-align: center; font-weight: bold;">分数</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(student, index) in formattedStudentList" :key="index">
            <td style="padding: 6px 4px; border-right: 1px solid #000; border-top: 1px solid #000; text-align: center;">{{ student.index }}</td>
            <td style="padding: 4px; border-right: 1px solid #000; border-top: 1px solid #000; text-align: center;">
              <img v-if="student.avatarUrl" :src="student.avatarUrl" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; border: 1px solid #ddd;" />
              <span v-else style="font-size: 9px; color: #999;">无头像</span>
            </td>
            <td style="padding: 6px 4px; border-right: 1px solid #000; border-top: 1px solid #000; text-align: center;">{{ student.name }}</td>
            <td style="padding: 6px 4px; border-right: 1px solid #000; border-top: 1px solid #000; text-align: center;">{{ student.sex }}</td>
            <td style="padding: 6px 4px; border-right: 1px solid #000; border-top: 1px solid #000; text-align: center;">{{ student.idCard }}</td>
            <td style="padding: 6px 4px; border-right: 1px solid #000; border-top: 1px solid #000; text-align: center; font-weight: bold;" :style="{ color: student.result === '通过' ? '#008000' : '#ff0000' }">{{ student.result }}</td>
            <td style="padding: 6px 4px; border-top: 1px solid #000; text-align: center;">{{ student.score }}</td>
          </tr>
        </tbody>
      </table>

      <!-- 公章区域 -->
      <div style="margin-top: 30px; display: flex; justify-content: space-between; align-items: flex-end;">
        <div style="flex: 1;">
          <div style="font-size: 12px; margin-bottom: 10px;">所属单位安全教育培训管理部门签章：</div>
          <div style="font-size: 12px;">网络安全教育平台</div>
        </div>
        <div style="position: relative; width: 100px; height: 100px;">
          <img src="/static/system/zhang.png" style="width: 100%; height: 100%; object-fit: contain;" />
        </div>
      </div>

      <!-- 日期区域 -->
      <div style="margin-top: 20px; text-align: right; font-size: 12px;">
        {{ ExamDate }}
      </div>
    </div>
  </div>
</template>

<script>
import docxtemplater from 'docxtemplater'
import PizZip from 'pizzip'
import JSZipUtils from 'jszip-utils'
import { saveAs } from 'file-saver'
import ImageModule from 'docxtemplater-image-module-free'
import html2canvas from 'html2canvas'
import { jsPDF } from 'jspdf'

export default {
  props: {
    value: Object,
    config: Object,
    ExamTicketList: Array,
    UserCount: Number,
    CompleteCount: Number,
    NoComplete: Number
  },
  computed: {
    hasData() {
      return (this.ExamTicketList || []).length > 0
    },
    File() {
      return {
        Title: '企业学员培训记录',
        Url: '/static/File/Template.docx'
      }
    },
    SiteUrl() {
      return this.$matrix.Config.ImageSite || ''
    },
    isDevEnv() {
      const host = (typeof window !== 'undefined' && window.location && window.location.hostname) || ''
      return host === 'localhost' || host === '127.0.0.1' || host.startsWith('192.168.') || host.startsWith('10.')
    },
    ExamDate() {
      if (this.value?.CreateTime) {
        return this.value.CreateTime.substr(0, 7)
      }
      return ''
    },
    ExamRange() {
      if (this.value?.CreateTime) {
        const createDate = new Date(this.value.CreateTime)
        const Year = createDate.getFullYear()
        const Month = createDate.getMonth() + 1
        const Day = new Date(Year, Month, 0).getDate()
        return `${Year}年${Month > 9 ? Month : '0' + Month}月01日-${Year}年${Month > 9 ? Month : '0' + Month}月${Day}日`
      }
      return ''
    },
    LessonsTimeLen() {
      if (this.value?.LessonsList && this.value.LessonsList.length) {
        const totalSeconds = this.value.LessonsList.reduce((t, n) => t + (n.LearnTime || 0), 0)
        return this.getDuration(totalSeconds)
      }
      return '00分00秒'
    },
    formattedStudentList() {
      return (this.ExamTicketList || []).map((item, index) => {
        const userId = item.Users?.Id ?? item.Users?.ID ?? item.UsersID
        const faceImage = item.Users?.FaceImage2 ?? item.Users?.FaceImage ?? item.Users?.Avatar
        const avatarBase64 = userId ? this.avatarBase64Map[userId] : ''
        let avatarUrl = ''
        if (avatarBase64) {
          avatarUrl = avatarBase64
        } else if (faceImage) {
          const fullUrl = `${this.SiteUrl}${faceImage}`
          avatarUrl = this.resolveImageUrl(fullUrl)
        }
        return {
          index: index + 1,
          name: item.Users?.NickName || '',
          sex: item.Users?.Sex === 1 ? '男' : '女',
          idCard: item.Users?.IDCard || '',
          result: item.ExamResult === 2 ? '通过' : '不通过',
          score: item.ExamScore || 0,
          avatarUrl: avatarUrl
        }
      })
    }
  },
  data() {
    return {
      isExportingWord: false,
      wordPercentage: 0,
      wordTotal: 0,
      wordStep: 0,
      isExportingPDF: false,
      pdfPercentage: 0,
      pdfTotal: 0,
      pdfStep: 0,
      avatarBase64Map: {}
    }
  },
  methods: {
    // 【关键】本地开发环境，把跨域图片URL转成走本地代理的相对路径
    resolveImageUrl(url) {
      if (!url || !this.isDevEnv) return url
      if (url.startsWith('/') || url.startsWith('data:')) return url
      try {
        const u = new URL(url, window.location.origin)
        if (u.hostname === window.location.hostname) return url
        const host = u.hostname.toLowerCase()
        const pathWithQuery = u.pathname + (u.search || '')
        let proxyPrefix = '/image-proxy'
        if (host.includes('s.apjdpx.com')) proxyPrefix = '/proxy-s'
        else if (host.includes('wx.apjdpx.com')) proxyPrefix = '/proxy-wx'
        const proxied = `${proxyPrefix}${pathWithQuery}`
        return proxied
      } catch (e) {
        return url
      }
    },
    // 【终极方案】把一个URL通过fetch+代理方式转成base64
    async forceUrlToBase64(url, tag = '') {
      if (!url || url.startsWith('data:')) return url || ''
      const proxiedUrl = this.resolveImageUrl(url)
      try {
        const response = await fetch(proxiedUrl, {
          method: 'GET',
          credentials: 'include',
          cache: 'no-cache'
        })
        if (!response.ok) return ''
        const blob = await response.blob()
        if (blob.size === 0) return ''
        return await new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.onloadend = () => resolve(reader.result || '')
          reader.onerror = (err) => reject(err)
          reader.readAsDataURL(blob)
        })
      } catch (e) {
        return ''
      }
    },
    // 【终极方案】直接遍历 pdfContent 里所有 img，把非 data:/static 的 src 强制替换为 base64
    async forceReplaceImagesToBase64(rootEl) {
      if (!rootEl) return { total: 0, success: 0 }
      const imgs = Array.from(rootEl.querySelectorAll('img'))
      let success = 0
      for (let i = 0; i < imgs.length; i++) {
        const img = imgs[i]
        const originalSrc = img.getAttribute('src') || ''
        if (originalSrc.startsWith('data:')) {
          if (originalSrc.length > 1000) success++
          continue
        }
        if (originalSrc.startsWith('/static/')) {
          if (img.complete && img.naturalWidth > 0) success++
          continue
        }
        const b64 = await this.forceUrlToBase64(originalSrc, `img${i+1}`)
        if (b64 && b64.length > 1000) {
          img.setAttribute('src', b64)
          await new Promise((resolve) => {
            if (img.complete && img.naturalWidth > 0) return resolve()
            const t = setTimeout(resolve, 2000)
            img.onload = () => { clearTimeout(t); resolve() }
            img.onerror = () => { clearTimeout(t); resolve() }
          })
          success++
        }
      }
      return { total: imgs.length, success }
    },
    // 【更可靠】使用 fetch + blob + FileReader 把URL转为base64
    async urlToBase64ByFetch(url, index = '') {
      const logPrefix = index ? `[头像${index}]` : '[头像]'
      try {
        const response = await fetch(url, {
          method: 'GET',
          credentials: 'include',
          cache: 'no-cache'
        })
        if (!response.ok) throw new Error(`HTTP ${response.status}`)
        const blob = await response.blob()
        if (blob.size === 0) return ''
        return await new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.onloadend = () => resolve(reader.result || '')
          reader.onerror = (err) => reject(err)
          reader.readAsDataURL(blob)
        })
      } catch (e) {
        throw e
      }
    },
    getDuration(seconds) {
      const m = Math.floor(seconds / 60)
      const s = Math.floor(seconds % 60)
      return `${m > 9 ? m : '0' + m}分${s > 9 ? s : '0' + s}秒`
    },
    async getBase64Sync(ImageUrl, type = 'word') {
      return new Promise((resolve) => {
        if (!ImageUrl) {
          resolve("")
          return
        }
        const image = new Image()
        image.crossOrigin = 'anonymous'
        image.src = `${ImageUrl}?t=${new Date().getTime()}`
        image.onload = () => {
          try {
            const minSize = Math.min(image.width, image.height)
            const cropX = (image.width - minSize) / 2
            const cropY = (image.height - minSize) / 2
            const targetSize = type === 'word' ? 120 : 40
            const canvas = document.createElement('canvas')
            canvas.width = targetSize
            canvas.height = targetSize
            const ctx = canvas.getContext('2d')
            ctx.imageSmoothingEnabled = true
            ctx.imageSmoothingQuality = 'high'
            ctx.drawImage(image, cropX, cropY, minSize, minSize, 0, 0, targetSize, targetSize)
            const ext = image.src.split('.').pop().toLowerCase()
            const quality = type === 'word' ? 1.0 : 0.95
            const dataurl = canvas.toDataURL(`image/${ext === 'png' ? 'png' : 'jpeg'}`, quality)
            resolve(dataurl)
          } catch (e) {
            resolve("")
          }
        }
        image.onerror = () => {
          resolve("")
        }
      })
    },
    base64DataURLToArrayBuffer(dataURL) {
      const base64Regex = /^data:image\/(png|jpg|jpeg);base64,/
      if (!base64Regex.test(dataURL)) return false
      const stringBase64 = dataURL.replace(base64Regex, '')
      const binaryString = window.atob(stringBase64)
      const len = binaryString.length
      const bytes = new Uint8Array(len)
      for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i)
      }
      return bytes.buffer
    },
    async OnCreateWord() {
      const list = this.ExamTicketList || []
      this.isExportingWord = true
      this.wordStep = 0
      this.wordPercentage = 0
      this.wordTotal = list.length

      try {
        JSZipUtils.getBinaryContent(this.File.Url, async (error, content) => {
          if (error) {
            throw new Error(`读取模板失败：${error.message}`)
          }

          const processedList = []
          for (let i = 0; i < list.length; i++) {
            const item = list[i]
            let faceImage = ""
            const facePath = item.Users?.FaceImage2 ?? item.Users?.FaceImage ?? item.Users?.Avatar
            if (facePath) {
              const fullUrl = this.resolveImageUrl(this.SiteUrl + facePath)
              try {
                faceImage = await this.urlToBase64ByFetch(fullUrl, i + 1)
              } catch (e) {
                try {
                  faceImage = await this.getBase64Sync(fullUrl, 'word')
                } catch (e2) { /* ignore */ }
              }
            }

            processedList.push({
              Index: i + 1,
              NickName: item.Users?.NickName || '',
              Sex: item.Users?.Sex === 1 ? '男' : '女',
              IDCard: item.Users?.IDCard || '',
              ExamResult: item.ExamResult === 2 ? '通过' : '不通过',
              ExamScore: item.ExamScore || 0,
              FaceImage: faceImage
            })

            this.wordStep++
            this.wordPercentage = Math.min(Math.floor((this.wordStep / this.wordTotal) * 100), 100)
          }

          const WordData = {
            Name: this.value?.Title || '',
            Company: this.value?.Company?.Name || '',
            ExamRange: this.ExamRange,
            ExamDate: this.ExamDate,
            VideoCount: this.value?.VideoCount || 0,
            LessonsTimeLen: this.LessonsTimeLen,
            UserCount: this.UserCount || 0,
            CompleteCount: this.CompleteCount || 0,
            NoComplete: this.NoComplete || 0,
            ExamTicketList: processedList
          }

          const opts = {
            centered: true,
            fileType: 'docx',
            getImage: (dataURL) => this.base64DataURLToArrayBuffer(dataURL),
            getSize: () => [60, 60]
          }

          const imageModule = new ImageModule(opts)
          const zip = new PizZip(content)
          const doc = new docxtemplater()
            .loadZip(zip)
            .attachModule(imageModule)
            .setOptions({ nullGetter: () => '', linebreaks: true })
            .setData(WordData)

          doc.render()

          const out = doc.getZip().generate({
            type: 'blob',
            mimeType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            compression: 'STORE'
          })

          saveAs(out, `${this.value?.Title || '培训记录'}.docx`)
          this.wordPercentage = 100
          this.$message.success('Word 导出成功！')
        })
      } catch (error) {
        console.error('Word 导出失败：', error)
        this.$message.error(`Word 导出失败：${error.message}`)
      } finally {
        setTimeout(() => {
          this.isExportingWord = false
          this.wordPercentage = 0
          this.wordStep = 0
        }, 1000)
      }
    },
    async OnCreatePDF() {
      this.isExportingPDF = true
      this.pdfPercentage = 0
      try {
        // 1. 批量把头像转 base64（走本地代理绕过CORS）
        const list = this.ExamTicketList || []
        this.pdfPercentage = 10
        for (let i = 0; i < list.length; i++) {
          const item = list[i]
          const userId = item.Users?.Id ?? item.Users?.ID ?? item.UsersID
          const faceImage = item.Users?.FaceImage2 ?? item.Users?.FaceImage ?? item.Users?.Avatar
          if (userId && faceImage && !this.avatarBase64Map[userId]) {
            const fullUrl = this.resolveImageUrl(`${this.SiteUrl}${faceImage}`)
            try {
              this.avatarBase64Map[userId] = await this.urlToBase64ByFetch(fullUrl, i + 1)
            } catch (e) {
              try {
                this.avatarBase64Map[userId] = await this.getBase64Sync(fullUrl, 'pdf')
              } catch (e2) { this.avatarBase64Map[userId] = '' }
            }
          }
          this.pdfPercentage = 10 + Math.floor((i + 1) / list.length * 40)
        }
        await this.$nextTick()

        const content = this.$refs.pdfContent
        if (!content) throw new Error('未找到PDF导出容器')

        // 临时移到可见区域，确保截图正常
        const originalStyle = content.getAttribute('style') || ''
        content.style.top = '0'
        content.style.left = '-99999px'
        content.style.zIndex = '-1'

        // 2. 等待DOM中所有图片加载完成
        const images = content.querySelectorAll('img')
        const imgPromises = Array.from(images).map((img) => {
          return new Promise((resolve) => {
            if (img.complete && img.naturalWidth > 0) return resolve()
            const t = setTimeout(resolve, 3000)
            img.onload = () => { clearTimeout(t); resolve() }
            img.onerror = () => { clearTimeout(t); resolve() }
          })
        })
        await Promise.all(imgPromises)
        await new Promise((r) => setTimeout(r, 400))
        this.pdfPercentage = 50

        // =================================================================
        // 【终极暴力步骤】遍历 pdfContent 里所有 img，把非 data:/static 的 src 强制替换为 base64
        // =================================================================
        const forceResult = await this.forceReplaceImagesToBase64(content)
        console.log(`[PDF导出] 强制替换完成: 成功 ${forceResult.success}/${forceResult.total}`)
        await new Promise((r) => setTimeout(r, 800))
        this.pdfPercentage = 60

        const canvas = await html2canvas(content, {
          scale: 2,
          useCORS: true,
          backgroundColor: '#ffffff',
          logging: false,
          letterRendering: true,
          allowTaint: true
        })
        this.pdfPercentage = 80

        content.setAttribute('style', originalStyle)

        let imgData
        try {
          imgData = canvas.toDataURL('image/jpeg', 1.0)
        } catch (e) {
          throw new Error('图片跨域导致画布被污染，请重启前端(dev server)后再试')
        }

        const pdf = new jsPDF({
          orientation: 'portrait',
          unit: 'mm',
          format: 'a4'
        })
        const imgWidth = 210
        const imgHeight = (canvas.height * imgWidth) / canvas.width
        let heightLeft = imgHeight
        let position = 0
        const pageHeight = 297
        pdf.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight)
        heightLeft -= pageHeight
        while (heightLeft > 0) {
          position = position - pageHeight
          pdf.addPage()
          pdf.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight)
          heightLeft -= pageHeight
        }
        this.pdfPercentage = 100
        pdf.save(`${this.value?.Title || '企业学员培训记录'}.pdf`)
        this.$message.success('PDF 导出成功！')
      } catch (error) {
        console.error('PDF 导出失败：', error)
        this.$message.error(`PDF 导出失败：${error.message}`)
      } finally {
        this.isExportingPDF = false
        setTimeout(() => {
          this.pdfPercentage = 0
          this.pdfStep = 0
        }, 3000)
      }
    }
  }
}
</script>

<style scoped>
.export-container {
  width: 100%;
  padding: 10px;
}
.export-buttons {
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
  align-items: flex-end;
}
@media (max-width: 768px) {
  .export-buttons {
    flex-direction: column;
    align-items: flex-start;
  }
  .el-progress {
    width: 100% !important;
  }
}
.pdf-content {
  font-family: 'Microsoft YaHei', 'SimHei', sans-serif !important;
}
.pdf-content img {
  image-rendering: -webkit-optimize-contrast;
  image-rendering: crisp-edges;
}
</style>